/* =========================================================
   Cozie · Storefront JS
   Cart drawer, quick-add, PDP tabs, filter dropdowns,
   variant picker, free-shipping progress bar.
   ========================================================= */

(function () {
  'use strict';

  const FREE_SHIPPING_CENTS = 9900; // $99 AUD in cents

  /* ───────────────────────────────────────────────────── */
  /* Cart drawer                                             */
  /* ───────────────────────────────────────────────────── */
  const drawer  = document.getElementById('cz-cart-drawer');
  const overlay = document.getElementById('cz-cart-overlay');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('cz-cart-drawer--open');
    if (overlay) overlay.classList.add('cz-cart-overlay--open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('cz-cart-drawer--open');
    if (overlay) overlay.classList.remove('cz-cart-overlay--open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cz-cart-open]'))  { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cz-cart-close]')) { closeDrawer(); }
  });

  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ───────────────────────────────────────────────────── */
  /* Cart API helpers                                        */
  /* ───────────────────────────────────────────────────── */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } }).then(r => r.json());
  }

  function cartChange(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    }).then(r => r.json());
  }

  function cartAdd(variantId, quantity, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1, properties: properties || {} }),
    }).then(r => r.json());
  }

  /* ───────────────────────────────────────────────────── */
  /* Render cart                                             */
  /* ───────────────────────────────────────────────────── */
  function updateCartCount(cart) {
    document.querySelectorAll('[data-cz-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
    });
  }

  function updateShippingBar(cart) {
    const bar  = document.querySelector('.cz-shipping-bar__fill');
    const msg  = document.querySelector('[data-cz-shipping-msg]');
    if (!bar) return;

    const pct       = Math.min(100, (cart.total_price / FREE_SHIPPING_CENTS) * 100);
    const remaining = Math.max(0, FREE_SHIPPING_CENTS - cart.total_price);

    bar.style.width = pct + '%';
    bar.classList.toggle('cz-shipping-bar__fill--complete', remaining === 0);

    if (msg) {
      if (remaining > 0) {
        msg.innerHTML = 'You\'re <strong>$' + Math.ceil(remaining / 100) + '</strong> away from free shipping';
      } else {
        msg.textContent = '✓ Free shipping unlocked';
        msg.style.fontWeight = '500';
      }
    }
  }

  function renderCartItems(cart) {
    const container = document.getElementById('cz-cart-items');
    const empty     = document.getElementById('cz-cart-empty');
    const content   = document.getElementById('cz-cart-content');

    updateCartCount(cart);
    updateShippingBar(cart);

    // Update drawer count subtitle
    const countEl = document.querySelector('.cz-cart-drawer__count');
    if (countEl) {
      countEl.textContent = cart.item_count === 0
        ? 'Empty'
        : cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's');
    }

    if (!container) return;

    if (cart.item_count === 0) {
      if (empty)   empty.style.display   = '';
      if (content) content.style.display = 'none';
      return;
    }

    if (empty)   empty.style.display   = 'none';
    if (content) content.style.display = '';

    container.innerHTML = cart.items.map(function (item) {
      var variant = item.variant_title ? item.variant_title : '';
      var imgHtml = item.featured_image && item.featured_image.url
        ? '<img src="' + item.featured_image.url + '" alt="' + item.product_title + '" loading="lazy" width="84">'
        : '';
      return '<div class="cz-cart-item" data-key="' + item.key + '">'
        + '<div class="cz-cart-item__media">' + imgHtml + '</div>'
        + '<div>'
        +   '<div class="cz-cart-item__name">' + item.product_title + '</div>'
        +   (variant ? '<div class="cz-cart-item__meta">' + variant + '</div>' : '')
        +   '<div class="cz-qty-stepper">'
        +     '<button class="cz-qty-stepper__btn" data-cz-qty="-1" data-key="' + item.key + '" aria-label="Decrease">−</button>'
        +     '<span class="cz-qty-stepper__count">' + item.quantity + '</span>'
        +     '<button class="cz-qty-stepper__btn" data-cz-qty="1" data-key="' + item.key + '" aria-label="Increase">+</button>'
        +   '</div>'
        +   '<button class="cz-cart-item__remove" data-cz-remove="' + item.key + '">Remove</button>'
        + '</div>'
        + '<div class="cz-cart-item__price">$' + (item.final_line_price / 100).toFixed(2) + '</div>'
        + '</div>';
    }).join('');

    // Subtotal
    var subtotalEl = document.getElementById('cz-cart-subtotal');
    if (subtotalEl) subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);

    var shippingEl = document.getElementById('cz-cart-shipping');
    if (shippingEl) shippingEl.textContent = cart.total_price >= FREE_SHIPPING_CENTS ? 'Free' : 'Calculated at checkout';

    var checkoutBtn = document.getElementById('cz-cart-checkout');
    if (checkoutBtn) checkoutBtn.textContent = 'Checkout · $' + (cart.total_price / 100).toFixed(2);

    // Bundle nudge
    var hasPillow = cart.items.some(function (i) {
      return (i.product_type || '').toLowerCase().includes('pillow') ||
             (i.title || '').toLowerCase().includes('pillow');
    });
    var nudge = document.getElementById('cz-cart-nudge');
    if (nudge) nudge.style.display = (cart.item_count > 0 && !hasPillow) ? '' : 'none';
  }

  function refreshCart() {
    fetchCart().then(renderCartItems).catch(function () {});
  }

  /* ───────────────────────────────────────────────────── */
  /* Add to cart + open drawer                              */
  /* ───────────────────────────────────────────────────── */
  function addAndOpen(variantId, quantity, properties) {
    return cartAdd(variantId, quantity, properties)
      .then(refreshCart)
      .then(openDrawer);
  }

  /* Quick-add on collection cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cz-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.dataset.czQuickAdd;
    if (!id) return;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = '…';
    addAndOpen(id, 1).catch(function () {}).finally(function () {
      btn.disabled = false;
      btn.textContent = orig;
    });
  });

  /* PDP add-to-bag */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cz-add-to-bag]');
    if (!btn) return;
    e.preventDefault();
    var form = document.getElementById('cz-product-form');
    if (!form) return;
    var input = form.querySelector('[name="id"]');
    if (!input || !input.value) return;
    var qty = parseInt(form.querySelector('[name="quantity"]') && form.querySelector('[name="quantity"]').value || 1);
    btn.disabled = true;
    addAndOpen(input.value, qty).catch(function () {}).finally(function () { btn.disabled = false; });
  });

  /* ───────────────────────────────────────────────────── */
  /* Qty steppers + remove (delegated)                      */
  /* ───────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cz-qty]');
    if (qtyBtn) {
      var key     = qtyBtn.dataset.key;
      var delta   = parseInt(qtyBtn.dataset.czQty);
      var stepper = qtyBtn.closest('.cz-qty-stepper');
      var countEl = stepper && stepper.querySelector('.cz-qty-stepper__count');
      var current = parseInt((countEl && countEl.textContent) || 1);
      var next    = Math.max(0, current + delta);
      cartChange(key, next).then(refreshCart).catch(function () {});
    }

    var removeBtn = e.target.closest('[data-cz-remove]');
    if (removeBtn) {
      cartChange(removeBtn.dataset.czRemove, 0).then(refreshCart).catch(function () {});
    }
  });

  /* ───────────────────────────────────────────────────── */
  /* PDP: tabs                                              */
  /* ───────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cz-tab-btn');
    if (!btn) return;
    var tabs   = btn.closest('.cz-tabs');
    if (!tabs) return;
    var target = btn.dataset.tab;
    tabs.querySelectorAll('.cz-tab-btn').forEach(function (b) {
      b.classList.toggle('cz-tab-btn--active', b === btn);
    });
    tabs.querySelectorAll('.cz-tab-panel').forEach(function (p) {
      p.classList.toggle('cz-tab-panel--active', p.dataset.tabPanel === target);
    });
  });

  /* ───────────────────────────────────────────────────── */
  /* Filter dropdowns                                       */
  /* ───────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cz-filter-toggle]');
    if (toggle) {
      var dd     = toggle.closest('.cz-filter-dropdown');
      var isOpen = dd.classList.contains('cz-filter-dropdown--open');
      document.querySelectorAll('.cz-filter-dropdown--open').forEach(function (d) {
        d.classList.remove('cz-filter-dropdown--open');
      });
      if (!isOpen) dd.classList.add('cz-filter-dropdown--open');
      return;
    }
    if (!e.target.closest('.cz-filter-dropdown')) {
      document.querySelectorAll('.cz-filter-dropdown--open').forEach(function (d) {
        d.classList.remove('cz-filter-dropdown--open');
      });
    }
  });

  /* ───────────────────────────────────────────────────── */
  /* PDP: color + size variant picker                       */
  /* ───────────────────────────────────────────────────── */
  function updateVariant() {
    var form = document.getElementById('cz-product-form');
    if (!form) return;

    var activeColor = document.querySelector('[data-cz-color].cz-color-swatch--active');
    var activeSize  = document.querySelector('[data-cz-size].cz-size-btn--active');
    var color = activeColor && activeColor.dataset.czColor;
    var size  = activeSize  && activeSize.dataset.czSize;

    var variantsEl = document.getElementById('cz-product-variants');
    if (!variantsEl) return;
    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (err) { return; }

    var match = variants.find(function (v) {
      var o1 = v.option1 || ''; var o2 = v.option2 || '';
      var colorMatch = !color || o1 === color || o2 === color;
      var sizeMatch  = !size  || o1 === size  || o2 === size;
      return colorMatch && sizeMatch;
    });

    if (!match) return;

    var input = form.querySelector('[name="id"]');
    if (input) input.value = match.id;

    var priceEl = document.getElementById('cz-pdp-price');
    if (priceEl && match.price) priceEl.textContent = '$' + (match.price / 100).toFixed(0);

    var addBtn = document.querySelector('[data-cz-add-to-bag]');
    if (addBtn && match.price) addBtn.textContent = 'Add to bag · $' + (match.price / 100).toFixed(0);
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-cz-color]');
    if (swatch) {
      document.querySelectorAll('[data-cz-color]').forEach(function (s) {
        s.classList.toggle('cz-color-swatch--active', s === swatch);
      });
      updateVariant();
    }

    var sizeBtn = e.target.closest('[data-cz-size]');
    if (sizeBtn) {
      document.querySelectorAll('[data-cz-size]').forEach(function (b) {
        b.classList.toggle('cz-size-btn--active', b === sizeBtn);
      });
      updateVariant();
    }
  });

  /* ───────────────────────────────────────────────────── */
  /* "Shop by feel" material filter chips (collection)      */
  /* ───────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-cz-material]');
    if (!chip) return;
    var material = chip.dataset.czMaterial;
    document.querySelectorAll('[data-cz-material]').forEach(function (c) {
      c.classList.toggle('cz-filter-btn--active', c === chip);
    });
    var url = new URL(window.location.href);
    if (material) {
      url.searchParams.set('filter.p.m.custom.material', material);
    } else {
      url.searchParams.delete('filter.p.m.custom.material');
    }
    window.location.href = url.toString();
  });

  /* ───────────────────────────────────────────────────── */
  /* Email capture success state                            */
  /* ───────────────────────────────────────────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cz-email-form]');
    if (!form) return;
    var success = form.parentElement && form.parentElement.querySelector('[data-cz-email-success]');
    if (success) {
      form.style.display = 'none';
      success.style.display = '';
    }
  });

  /* ───────────────────────────────────────────────────── */
  /* Init                                                   */
  /* ───────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCart);
  } else {
    refreshCart();
  }

})();
